import { Grid } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { colors } from 'styles';
import Chip from '@material-ui/core/Chip';

const StyledGrid = styled(Grid)`
  padding: 2rem;
`;
const StyledChip = styled(Chip)`
  margin: 1rem 1rem;
  padding: 1.5rem 1rem;
  background-color: rgba(173, 147, 160, 0.1);
  color: ${colors.black};
  font-family: ${props => `${props.theme.typography.fontFamily}
`};
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`};
  z-index: 10;
`;

const ActiveChip = styled(StyledChip)`
  background-color: ${colors.orange};
  color: ${colors.white};
`;
const BlockChip = ({ data, activeChip, handleChipChange, scrollHandler }) => {
  return (
    <Grid container justify={'center'} alignItems={'center'}>
      <StyledGrid
        container
        item
        xs={'auto'}
        sm={12}
        md={12}
        lg={8}
        justify={'center'}
      >
        {data.map((chip, index) => {
          if (chip.frontmatter.useCases === activeChip) {
            return (
              <ActiveChip
                label={
                  <FormattedMessage
                    id={'useCases.' + chip.frontmatter.useCases}
                  />
                }
                key={`Chip${index}`}
              />
            );
          } else if (chip.frontmatter.useCases !== activeChip) {
            return (
              <StyledChip
                label={
                  <FormattedMessage
                    id={'useCases.' + chip.frontmatter.useCases}
                  />
                }
                key={`Chip${index}`}
                clickable
                onClick={() => {
                  handleChipChange(chip.frontmatter.useCases);
                  scrollHandler();
                }}
              />
            );
          }
        })}
      </StyledGrid>
    </Grid>
  );
};
export default BlockChip;
